/** Contacto comercial (planos, demonstrações) enquanto os pagamentos não estão ligados. */
export const CONTACT_EMAIL = 'ricardo@rdoria.com';

export const mailto = (subject: string) =>
  `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;

/**
 * Identificação de quem presta o serviço (termos e política de privacidade; obrigatória por lei
 * no comércio eletrónico). Muda se o serviço passar para uma sociedade.
 */
export const LEGAL_NAME = 'Ricardo Dória'; // i18n-ignore: nome próprio
export const LEGAL_ADDRESS = 'Rua das Tulipas, n.º 19, 2005-456 Santarém'; // i18n-ignore: morada
export const LEGAL_TAX_ID = '259388050';
